import { Category } from '@/types';
import { logger } from '@/utils/logger';

export interface CategoriesState {
  categories: Category[];
  isLoading: boolean;
  lastLoadedProfile: string | null;
}

export type CategoriesAction =
  | { type: 'SET_LOADING'; payload: boolean }
  | { type: 'SET_CATEGORIES'; payload: Category[] }
  | { type: 'ADD_CATEGORY'; payload: Category }
  | { type: 'UPDATE_CATEGORY'; payload: { id: string; updates: Partial<Category> } }
  | { type: 'DELETE_CATEGORY'; payload: string }
  | { type: 'SET_LAST_LOADED_PROFILE'; payload: string | null }
  | { type: 'CLEAR_CATEGORIES' };

export const initialState: CategoriesState = {
  categories: [],
  isLoading: false,
  lastLoadedProfile: null,
};

export function categoriesReducer(
  state: CategoriesState,
  action: CategoriesAction
): CategoriesState {
  switch (action.type) {
    case 'SET_LOADING':
      return { ...state, isLoading: action.payload };

    case 'SET_CATEGORIES':
      return { 
        ...state, 
        categories: action.payload,
        isLoading: false
      };

    case 'ADD_CATEGORY':
      logger.debug('Adding category to state', { id: action.payload.id });
      return {
        ...state,
        categories: [...state.categories, action.payload],
      };

    case 'UPDATE_CATEGORY': {
      const updated = state.categories.map(c =>
        c.id === action.payload.id ? { ...c, ...action.payload.updates } : c
      );
      logger.debug('Updated category in state', { id: action.payload.id });
      return { ...state, categories: updated };
    }

    case 'DELETE_CATEGORY': {
      const filtered = state.categories.filter(c => c.id !== action.payload);
      logger.debug('Deleted category from state', { id: action.payload });
      return { ...state, categories: filtered };
    }

    case 'SET_LAST_LOADED_PROFILE':
      return { ...state, lastLoadedProfile: action.payload };

    case 'CLEAR_CATEGORIES':
      return { ...state, categories: [], lastLoadedProfile: null };

    default:
      return state;
  }
}
